import {DoubleRightOutlined, FunnelPlotOutlined, SearchOutlined, UndoOutlined} from "../../../__snowpack__/pkg/@ant-design/icons.js";
import {useKeyPress, useUpdateEffect} from "../../../__snowpack__/pkg/ahooks.js";
import {Button, Form, Modal, Space} from "../../../__snowpack__/pkg/antd.js";
import React, {useContext, useMemo, useRef} from "../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../__snowpack__/pkg/react-intl.js";
import "./index.css";
import {FormProvider} from "../../../__snowpack__/pkg/antd/lib/form/context.js";
import classNames from "../../../__snowpack__/pkg/classnames.js";
import GnForm, {GnFormContext} from "../GnForm/index.js";
import Tag from "./Tag.js";
import {TagsContext} from "./TagsContext.js";
export default function SearchForm(props) {
  const {
    search,
    children,
    mode = "modal",
    extra,
    modalProps,
    form,
    showActions = true,
    onFinish,
    setPage,
    ...restProps
  } = props;
  const {formatMessage} = useIntl();
  const formValuesCacheRef = useRef();
  const containerRef = useRef(null);
  let simpleChild;
  let advanceChild;
  let tagsContainer;
  if (Array.isArray(children)) {
    children.forEach((child) => {
      if (typeof child.type === "function" && child.type.displayName === "Simple") {
        simpleChild = child;
      } else if (typeof child.type === "function" && child.type.displayName === "Advance") {
        advanceChild = child;
      } else if (typeof child.type === "function" && child.type.displayName === "Tags") {
        tagsContainer = child;
      }
    });
  }
  if (simpleChild === void 0 && advanceChild === void 0) {
    simpleChild = Array.isArray(children) ? children.filter((child) => child.type.displayName !== "Tags") : children;
  }
  useUpdateEffect(() => {
    if (search.type === "advance") {
      formValuesCacheRef.current = form?.getFieldsValue(true);
    }
  }, [search.type]);
  useKeyPress(["enter"], (e) => {
    const target = e?.target;
    if (target?.tagName === "INPUT" && target?.type === "text") {
      setPage && setPage(0);
      search.submit();
    }
  }, {
    target: containerRef.current
  });
  const tagsContextValues = useMemo(() => ({searchType: search.type, searchMode: mode}), [search.type]);
  return /* @__PURE__ */ React.createElement(FormProvider, {
    onFormFinish: (_name, {values}) => {
      setPage && setPage(0);
      onFinish?.(values);
      search.submit();
    }
  }, /* @__PURE__ */ React.createElement(GnForm, {
    className: classNames(["search-form", `search-form--${search.type}`]),
    layout: "inline",
    form,
    ...restProps
  }, /* @__PURE__ */ React.createElement("div", {
    ref: containerRef,
    style: {display: "inline-flex", flexWrap: "wrap", flex: 1}
  }, simpleChild, mode === "modal" && /* @__PURE__ */ React.createElement(Modal, {
    title: formatMessage({id: "filter"}),
    width: "fit-content",
    visible: search.type === "advance",
    forceRender: true,
    onOk: () => {
      form?.submit();
      search.changeType();
    },
    onCancel: () => {
      form?.resetFields();
      form?.setFieldsValue(formValuesCacheRef.current);
      search.changeType();
    },
    ...modalProps,
    style: {minWidth: 400, maxWidth: "80vw", ...modalProps?.style}
  }, advanceChild), showActions && /* @__PURE__ */ React.createElement(Space, {
    className: "search-form-actions"
  }, advanceChild && mode === "collapse" && /* @__PURE__ */ React.createElement("div", {
    onClick: search.changeType
  }, /* @__PURE__ */ React.createElement(Button, {
    htmlType: "button",
    type: "link",
    size: "small",
    icon: /* @__PURE__ */ React.createElement(DoubleRightOutlined, {
      rotate: search.type === "advance" ? -90 : 90,
      style: {marginRight: -4}
    })
  }, search.type === "simple" && formatMessage({id: "unfold"}), search.type === "advance" && formatMessage({id: "collapse"}))), /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    icon: /* @__PURE__ */ React.createElement(SearchOutlined, null),
    loading: search.loading,
    onClick: form?.submit
  }, formatMessage({id: "search"})), advanceChild && mode === "modal" && /* @__PURE__ */ React.createElement(Button, {
    htmlType: "button",
    onClick: search.changeType,
    icon: /* @__PURE__ */ React.createElement(FunnelPlotOutlined, null),
    loading: search.loading
  }, formatMessage({id: "filter"})), /* @__PURE__ */ React.createElement(Button, {
    htmlType: "reset",
    type: "link",
    size: "small",
    onClick: () => {
      search.reset();
      setPage && setPage(0);
    },
    icon: /* @__PURE__ */ React.createElement(UndoOutlined, {
      style: {marginRight: -4}
    }),
    loading: search.loading
  }, formatMessage({id: "reset"}))), mode === "collapse" && search.type === "advance" && /* @__PURE__ */ React.createElement("div", {
    style: {display: "flex", width: "100%"}
  }, advanceChild), tagsContainer ? /* @__PURE__ */ React.createElement(TagsContext.Provider, {
    value: tagsContextValues
  }, tagsContainer) : null), !!extra && /* @__PURE__ */ React.createElement("div", {
    className: "search-form-extra"
  }, extra)));
}
const Simple = ({children}) => children;
Simple.displayName = "Simple";
const Advance = (props) => {
  const context = useContext(GnFormContext);
  return React.createElement(Form, {
    component: "div",
    ...props,
    initialValues: context?.formProps.initialValues,
    form: context?.form
  });
};
Advance.displayName = "Advance";
const Tags = ({children}) => /* @__PURE__ */ React.createElement("div", {
  className: "search-form-tags"
}, children);
Tags.displayName = "Tags";
SearchForm.Simple = Simple;
SearchForm.Advance = Advance;
SearchForm.Tags = Tags;
SearchForm.Tag = Tag;
SearchForm.Item = GnForm.Item;
SearchForm.useForm = GnForm.useForm;
